<script setup>
defineProps({
  value: null,
});
</script>

<template>
  <span ref="input" class="shadow-sm border text-sm rounded-lg block p-2.5 bg-white border-gray-200 text-gray-500 cursor-not-allowed"
        v-html="value"
  ></span>
</template>
